import { useMemo } from 'react';
import { isEntityStateArchived } from 'components/common/dataGrid/columnsFactory/types';
import { InspectionModel } from 'shared/domain/inspection/inspectionModel';
import { useInspectionStore } from '../../store';
import { useInspections } from '../useInspections';

export interface UseFilteredInspectionsResult {
  inspections: InspectionModel[];
  loading: boolean;
}

export function useFilteredInspections(): UseFilteredInspectionsResult {
  const { inspections, loading } = useInspections();
  const inspectionListState = useInspectionStore.use.inspectionListState();

  const showArchived = isEntityStateArchived(inspectionListState);

  const items = useMemo(
    () =>
      inspections.items.filter((inspection) =>
        showArchived ? inspection.deleted : !inspection.deleted
      ),
    [inspections.items, showArchived]
  );

  return {
    inspections: items,
    loading,
  };
}
